import { useState } from 'react'
import Icon from 'components/Icon'
import Button from 'components/form/Button'
import PropTypes from 'prop-types'
import NoneAnchor from 'components/NoneAnchor'
import ad from 'api/axios/foka/ad'
import { useAlert } from 'features/dialog/Alert'
import { useHistory, useParams } from 'react-router-dom'
import { DASHBOARD_REFERRER } from 'features/ad/useDashboardReferrer'
import { CampaignTypes } from '../../../Codes'

const CreateCampaignButton = ({ type = 'button' }) => {
  const { accountId } = useParams()
  const [disabled, setDisabled] = useState(false)
  const history = useHistory()
  const [FailedAlert, showFailedAlert] = useAlert()
  const handleCreate = async () => {
    setDisabled(true)
    try {
      const [premiumlinkGenerable, talkchannelGenerable] = await Promise.all([
        ad.getCampaignGenerable(CampaignTypes.PREMIUM_LINK),
        ad.getCampaignGenerable(CampaignTypes.TALK_CHANNEL),
      ])
      const generable =
        premiumlinkGenerable.data?.generable ||
        talkchannelGenerable.data?.generable
      if (generable === false) {
        showFailedAlert()
      } else {
        history.push(
          `/${accountId}/ads/campaigns/new?from=${DASHBOARD_REFERRER.CAMPAIGN}`
        )
      }
    } catch (ignore) {}
    setDisabled(false)
  }
  return (
    <>
      {type === 'button' ? (
        <Button primary disabled={disabled} onClick={handleCreate}>
          <Icon className="img_comm" name="add" />
          캠페인 만들기
        </Button>
      ) : (
        <NoneAnchor
          className="link_txt"
          onClick={handleCreate}
          style={disabled ? { pointerEvents: 'none' } : undefined}>
          캠페인 만들기
        </NoneAnchor>
      )}
      <FailedAlert title="캠페인 제한수 초과">
        개수 제한으로 캠페인 만들기를 할 수 없습니다.
        <br />
        캠페인 삭제후 다시 진행하세요.
      </FailedAlert>
    </>
  )
}
CreateCampaignButton.propTypes = {
  type: PropTypes.oneOf(['button', 'link']),
}
export default CreateCampaignButton
